import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum EmotoradOus {
    Country = "87da9002-f664-5bce-9f09-6f88260b938d",
    Zone = "12a598fd-dcb8-4e7a-88f9-978b738cfb7d",
    State = "96bb7d28-8694-58a7-9db6-ec12fb73df8a",
    Area = "d42aa3d7-976f-5326-a506-ac9ef478ab90",
    Dealership = "7e539435-bb4d-5a36-a21f-6fdb999ec6ad",
}

export const EMOTORAD__OU__COUNTRY__NAME__COLUMN_ID = "1c383d03-e02c-5438-80a3-56f2983a8c36" as Uuid;

export const EMOTORAD__OU__ZONE__NAME__COLUMN_ID = "adcd786f-b7c0-4b2b-b748-17f0682d1197" as Uuid;

export const EMOTORAD__OU__STATE__NAME__COLUMN_ID = "943e0b68-0b78-5e0e-bed3-709c88fb1ea9" as Uuid;

export const EMOTORAD__OU__AREA__NAME__COLUMN_ID = "aca6c7ae-9b90-5e93-9d0c-ee6dfa9b7d3c" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__NAME__COLUMN_ID = "4985da16-0de2-5668-b027-51a9248cc28e" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__STATE__COLUMN_ID = "412d6bf5-5a4b-47a2-bfac-b1e77585bc23" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__CITY__COLUMN_ID = "c26907d7-e9dc-45c2-8695-b7b1221afe52" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__PINCODE__COLUMN_ID = "aa71be32-4569-4d00-95f0-b6bcd87473b1" as Uuid;

export const EMOTORAD__OU_DEALERSHIP_FRANCHISE__COLUMN_ID = "31d75677-9028-4a5c-9d1f-b98854746557" as Uuid;

export const EMOTORAD__OU_DEALERSHIP_LAT__COLUMN_ID = "3a050c82-e0c6-4c57-9a06-6e93ab688826" as Uuid;

export const EMOTORAD__OU_DEALERSHIP_LONG__COLUMN_ID = "f0f5811d-514d-48ea-b9ea-4e5f85165473" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__OWNER_NAME__COLUMN_ID = "3f130008-c16c-48ae-b2f7-0ba7b7358426" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__OWNER_CONTACT_NUMBER__COLUMN_ID = "cc851e1a-7cd9-41b5-adf7-f8e0524ff673" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__OWNER_EMAIL__COLUMN_ID = "bbdb3f9d-9cd9-4984-aa52-1333692cb408" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__TOTAL_SSE_COUNT__COLUMN_ID = "ee0347a7-6c66-4ff0-9e4b-2428f4c9f810" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__TOTAL_LEADS_ASSIGNED__COLUMN_ID = "f3c6a169-ddb7-4f16-a5ef-834cc5cac58c" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__ACTIVE_LEADS_COUNT__COLUMN_ID = "bbf2b4e0-fa0a-4e6d-82dd-2e5719a834b7" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__CONVERTED_LEADS_COUNT__COLUMN_ID = "27ad1a6b-d41e-4baf-acb1-361585ce3ca5" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__HOUSE_NUMBER__COLUMN_ID = "ce9d903e-c719-4e23-ba1b-40831df3cc8f" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__AREA_LOCALITY__COLUMN_ID = "56173ed0-bee9-41b1-9cd8-067d24c47980" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__GST_NUMBER__COLUMN_ID = "4437f46f-28f9-4ba5-b25b-d4064ce30013" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__PAN__COLUMN_ID = "cf3ba707-c8cb-4489-94ca-9f5a0635ec1e" as Uuid;

export const EMOTORAD__OU__DEALERSHIP__AADHAR__COLUMN_ID = "66b0101f-83c5-453c-880e-f599fc1ff83c" as Uuid;
